/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * withStylesProps
 *
 * @file withStylesProps.jsx
 * @author Mohamed yasar arabath M
 * @since 0.0.1
 */
import React from 'react';
import { withStyles } from '@material-ui/core';

const withStylesProps = (styles, forwardedRef = null) => Component => props => {
  const ref = forwardedRef && props[forwardedRef];
  const Comp = withStyles(theme => styles(theme, props))(Component);

  return !ref ? <Comp {...props} /> : <Comp {...props} ref={ref} />;
};
export default withStylesProps;
